// extracted by mini-css-extract-plugin
export default {"wrap":"PeriodsComponent_wrap__9tryw","btnBlock":"PeriodsComponent_btnBlock__cHd15","listBlock":"PeriodsComponent_listBlock__Zd4tS"};